import config from "./config";
var axios = config();

export default {
  getDeletionReasons() {
    return axios.get("/api/DeletionReasons/GetDeletionReasons");
  }
};
